import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'utils/ui/classes';
const Node = (props) => {
    const routeConnector = props.lastStop ? 'none' : '';
    return (React.createElement("div", { className: cn('cursor-pointer', props.className) },
        React.createElement("svg", { height: "60", width: "30" },
            React.createElement("g", null,
                React.createElement("circle", { cx: 15, cy: 15, r: 15, fill: props.color }),
                !props.selectedForSplit && (React.createElement("text", { y: "20", x: "15", textAnchor: "middle", style: { fill: 'white' } }, props.sequence)),
                props.selectedForSplit && (React.createElement("path", { style: { transform: 'translate(5px, 5px)' }, fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd", fill: "white" }))),
            React.createElement("line", { x1: "15", y1: "40", x2: "15", y2: "130", style: {
                    zIndex: 1000,
                    stroke: '#BDCEE0',
                    strokeWidth: 5,
                    display: routeConnector,
                } }))));
};
Node.propTypes = {
    color: PropTypes.string.isRequired,
    lastStop: PropTypes.bool,
    sequence: PropTypes.number.isRequired,
};
Node.defaultProps = {
    lastStop: false,
};
export default Node;
